import { Component } from '@angular/core';

@Component({
  selector: 'fgb-worksheet-gallery',
  templateUrl: './worksheet-gallery.component.html',
  styleUrl: './worksheet-gallery.component.scss',
})
export class WorksheetGalleryComponent {

}
